
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lib/book/[id]/read",
      function () {
        return require("private-next-pages/lib/book/[id]/read/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lib/book/[id]/read"])
      });
    }
  